import { useQuery } from '@tanstack/react-query';

import { $api } from '../../global';
import { IOTMQuiz } from '../models';
import { OTMListConst } from '..';

export const useOTMQuizTest = () => {
  const { data: otmQuiz, ...args } = useQuery<IOTMQuiz[]>({
    queryKey: [OTMListConst.queryKeys.ALL_OTM_LIST_QUIZ],
    queryFn: async () => {
      const { data } = await $api.get('/quiz-test');

      return data;
    }
  });

  return { otmQuiz, ...args };
};
